import React, { useState } from "react";
import { toast } from "sonner";
import { Mail, Send, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useApi } from "../hooks/useApi";
import { DashboardLayout } from "../components/layout/DashboardLayout";

const COLORS = {
  principale: '#210875',
  accent: '#897FCB',
  bg: '#FDFCFF',
};

export const ContactPage = () => {
  const [formData, setFormData] = useState({ name: "", email: "", subject: "", message: "" });
  const [sending, setSending] = useState(false);
  const api = useApi();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    
    try {
      await api.post("/contact", formData);
      toast.success("Message envoyé !");
      setFormData({ name: "", email: "", subject: "", message: "" });
    } catch (err) {
      toast.error("Erreur lors de l'envoi");
    }
    
    setSending(false);
  };

  return (
    <DashboardLayout>
      <div className="max-w-2xl mx-auto" data-testid="contact-page">
        <button 
          onClick={() => navigate(-1)} 
          className="flex items-center gap-2 text-muted-foreground hover:text-foreground mb-6"
        >
          <ArrowLeft size={18} /> Retour
        </button>

        <div className="bg-card rounded-xl border p-6 md:p-8">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-12 h-12 rounded-full flex items-center justify-center" style={{ backgroundColor: COLORS.bg }}>
              <Mail size={24} style={{ color: COLORS.principale }} />
            </div>
            <div>
              <h1 className="text-2xl font-bold" style={{ color: COLORS.principale }}>Nous contacter</h1>
              <p className="text-muted-foreground">Une question ? Un problème ? Écrivez-nous !</p>
            </div>
          </div>

          {/* Email direct */}
          <div className="p-4 rounded-lg mb-6" style={{ backgroundColor: COLORS.bg }}>
            <p className="text-sm text-muted-foreground mb-1">Vous pouvez aussi nous écrire directement à :</p>
            <a 
              href="mailto:t.samblat@gmail.com" 
              className="font-medium flex items-center gap-2 hover:underline"
              style={{ color: COLORS.principale }}
            >
              <Mail size={16} /> t.samblat@gmail.com
            </a>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium mb-2">Votre nom</label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  className="w-full h-11 px-4 rounded-lg border border-input bg-background"
                  placeholder="Jean Dupont"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-2">Votre email</label>
                <input
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  className="w-full h-11 px-4 rounded-lg border border-input bg-background"
                  placeholder="jean@exemple.fr"
                  required
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">Sujet</label>
              <input
                type="text"
                value={formData.subject}
                onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
                className="w-full h-11 px-4 rounded-lg border border-input bg-background"
                placeholder="Question sur mon abonnement"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">Message</label>
              <textarea
                value={formData.message}
                onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                className="w-full px-4 py-3 rounded-lg border border-input bg-background resize-none"
                rows={5}
                placeholder="Décrivez votre demande..."
                required
              />
            </div>

            <button
              type="submit"
              disabled={sending}
              className="w-full h-12 rounded-lg text-white font-medium flex items-center justify-center gap-2 hover:opacity-90 transition-opacity disabled:opacity-50"
              style={{ backgroundColor: COLORS.principale }}
              data-testid="send-contact-btn"
            >
              {sending ? (
                <div className="animate-spin w-5 h-5 border-2 border-white border-t-transparent rounded-full" />
              ) : (
                <>
                  <Send size={18} /> Envoyer le message
                </>
              )}
            </button>
          </form>
        </div>
      </div>
    </DashboardLayout>
  );
};
